import { Trans } from '@lingui/macro';
import { clsx } from '@mantine/core';

import seatIcon from './seat-icon.svg';
import { SeatLocation } from './seat-location';
import { MaybeSeatParams, SeatParams } from './types';
import wagonIcon from './wagon-icon.svg';

import styles from './ticket-pass.module.css';

const hasSeatNumber = (seat: MaybeSeatParams): seat is SeatParams =>
  !!seat.seatNum && !!seat.wagonNum;

type TicketPassengersProps = {
  passengers: MaybeSeatParams[];
};
export const TicketPassengers = ({ passengers }: TicketPassengersProps) => {
  const hasSeats = passengers.every((pass) => hasSeatNumber(pass));

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.colHeaderTitle}>
            <Trans>Пассажиры</Trans>
          </th>
          {hasSeats && (
            <th className={clsx(styles.colHeaderTitle, styles.rightAlign)}>
              <Trans>Вагон и место</Trans>
            </th>
          )}
        </tr>
      </thead>

      <tbody>
        {passengers.map((seat, index) => (
          <tr key={`${seat.wagonNum}-${seat.seatNum}`} className={styles.row}>
            <td className={styles.cell}>
              <Trans>Пассажир</Trans> {index + 1}
            </td>

            {hasSeatNumber(seat) && (
              <td
                className={clsx(
                  styles.seatLocation,
                  styles.rightAlign,
                  styles.cell
                )}
              >
                <>
                  <SeatLocation icon={wagonIcon} number={seat.wagonNum} />
                  <SeatLocation icon={seatIcon} number={seat.seatNum} />
                </>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
